import AbsComponent from '../../common/components/AbsComponent';
import WinResize from '../../common/WinResize';
import Config from "../../search/Config";
import Template from "../../search/components/Template";

const parseRange = document.createRange();
const parse = Range.prototype.createContextualFragment.bind(parseRange);

class RemoteControll extends AbsComponent{
  constructor(_store={}, _el=''){
    super(_store, _el);
    this.createRemoteControll();
    this.addEvents();
   /* window.addEventListener('scroll', this.scroll.bind(this));
    this.resize();
    this.scroll();*/
  }

  createRemoteControll(){
    let markup='';
    markup = `
      <div class="remote-controll">
         <a href="javascript:;" class="remote-btn remote-btn-top"></a>
         <a href="javascript:;" class="remote-btn remote-btn-bottom"></a>
      </div>
      `;

    document.querySelector(this.el).appendChild(parse(markup));

  }
  addEvents() {
    let btns = document.querySelectorAll('.remote-controll>a');
    for(let btn of btns){
      btn.addEventListener('click', ()=>{
        let tarY = 0;
        if(btn.classList.contains('remote-btn-bottom')) {
          if (document.querySelector('.view-recent')) {
            tarY = document.querySelector('.view-recent').offsetTop;
          }else{
            tarY = document.querySelector('.footer-wrap').offsetTop;
          }
        }
        $('html, body').stop().animate({scrollTop:tarY}, this.store.srollSpeed);
      });
    }
  }

  scroll(){

  }

  setting(){
  }
  resize(){

  }
}
export default RemoteControll;
